export default "__VITE_ASSET__CGX1lW5S__"